import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/global.css'
import App from './App'
import { startWebVitals } from '@/monitoring/webVitals'
import { reportError } from '@/utils/logger'

startWebVitals()

createRoot(document.getElementById('root')!, {
  onCaughtError(error, errorInfo) {
    reportError('React caught an error boundary exception.', error, errorInfo)
  },
  onUncaughtError(error, errorInfo) {
    reportError('React hit an uncaught render error.', error, errorInfo)
  },
  onRecoverableError(error, errorInfo) {
    reportError('React recovered from an error.', error, errorInfo)
  },
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
